import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "as-player-logo" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "as-player-content" }
const _hoisted_4 = {
  key: 1,
  class: "as-time"
}
const _hoisted_5 = { class: "as-player-shirt" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }

import { computed } from "vue";
import type { IPlayer } from "~src/interfaces";
import { formatRateColor, getIncidentIcon } from "~src/helpers";
import IconHealthCare from "~src/components/icons/IconHealthCare.vue";
import IconRedCard from "~src/components/icons/IconRedCard.vue";
import { useMatchDetailStore } from "~src/stores/MatchDetailStore";

const __default__ = {};

interface IProps {
  player: IPlayer;
  flex: string;
  isInjuredSuspended: boolean;
  isSubstituted: boolean;
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'PlayerItemTab',
  props: {
    player: {},
    flex: { default: "start" },
    isInjuredSuspended: { type: Boolean, default: false },
    isSubstituted: { type: Boolean, default: false }
  },
  setup(__props: any) {

const matchDetailStore = useMatchDetailStore();



const screenWidth = computed(() => matchDetailStore.getScreenWidth);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["as-player", {
      'as-player-end': _ctx.flex === 'end',
      'as-player-sm': screenWidth.value < 370,
    }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        src: _ctx.getImgUrlBySport('player', _ctx.player.id)
      }, null, 8, _hoisted_2)
    ]),
    _createElementVNode("div", _hoisted_3, [
      (!_ctx.isInjuredSuspended)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["as-d-flex as-align-items-center as-gap-4", {
          'as-justify-content-end': _ctx.flex === 'end',
          'as-player-start': _ctx.flex === 'start',
        }])
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.player.incidents, (incident, incidentKey) => {
              return (_openBlock(), _createElementBlock("div", {
                key: incidentKey,
                class: "as-player-incident"
              }, [
                (_unref(getIncidentIcon)(_ctx.player, incident, _ctx.isSubstituted))
                  ? (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(getIncidentIcon)(_ctx.player, incident, _ctx.isSubstituted)), { key: 0 }))
                  : _createCommentVNode("", true),
                ([1, 9].includes(incident.type))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(incident.time) + "'", 1))
                  : _createCommentVNode("", true)
              ]))
            }), 128)),
            (_ctx.player.rating !== '0.0')
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "as-player-rating",
                  style: _normalizeStyle({
            background: _unref(formatRateColor)(parseFloat(_ctx.player.rating)),
          })
                }, _toDisplayString(_ctx.player.rating), 5))
              : _createCommentVNode("", true)
          ], 2))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        (_ctx.isInjuredSuspended)
          ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.player.shirt_number ? _ctx.player.shirt_number : "") + "-" + _toDisplayString(_ctx.player.name), 1))
          : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.player.shirt_number ? _ctx.player.shirt_number : "") + "-" + _toDisplayString(_ctx.player.position) + "." + _toDisplayString(_ctx.player.name), 1))
      ]),
      (_ctx.isInjuredSuspended)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass(["as-injured-suspended", {
          'as-text-right': _ctx.flex === 'end',
        }])
          }, [
            (_ctx.player.type === 1 && _ctx.flex !== 'end')
              ? (_openBlock(), _createBlock(IconHealthCare, { key: 0 }))
              : _createCommentVNode("", true),
            (_ctx.player.type === 2 && _ctx.flex !== 'end')
              ? (_openBlock(), _createBlock(IconRedCard, { key: 1 }))
              : _createCommentVNode("", true),
            _createElementVNode("span", {
              class: _normalizeClass(_ctx.player.type === 1 ? 'as-injured' : 'as-suspended')
            }, _toDisplayString(_ctx.player.type === 1 ? "Chấn thương" : "Treo giò"), 3),
            (_ctx.player.type === 1 && _ctx.flex === 'end')
              ? (_openBlock(), _createBlock(IconHealthCare, { key: 2 }))
              : _createCommentVNode("", true),
            (_ctx.player.type === 2 && _ctx.flex === 'end')
              ? (_openBlock(), _createBlock(IconRedCard, { key: 3 }))
              : _createCommentVNode("", true)
          ], 2))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})